import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import { useFormikContext } from 'formik'
import { isEmpty, isNil } from 'lodash'
import React from 'react'

import { TextField } from 'app/components/generic/FormElements'
import { validator, validateFee, validateNotEmpty } from 'app/validators'

const DeleteForm = (props) => {
  const { formData } = props
  const { errors, values, setFieldValue } = useFormikContext()

  return (
    <>
      <FormControl
        variant="outlined"
        {...(!isEmpty(errors.reason) ? { error: true } : null)}
        required
      >
        <TextField
          name={'reason'}
          label={'Reason'}
          variant="outlined"
          required
          validate={validateNotEmpty({ isRequired: true })}
        />
        {!isEmpty(errors.reason) && (
          <FormHelperText>{errors.reason}</FormHelperText>
        )}
      </FormControl>
    </>
  )
}

export default DeleteForm
